import React, { forwardRef } from 'react';
import { cn } from '../../lib/utils';
import { ChevronDown } from 'lucide-react';
export interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {}
const Select = forwardRef<HTMLSelectElement, SelectProps>(({
  className,
  children,
  ...props
}, ref) => {
  return <div className="relative" data-id="element-399">
        <select className={cn('flex h-10 w-full items-center justify-between rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 appearance-none', className)} ref={ref} {...props} data-id="element-400">
          {children}
        </select>
        <ChevronDown className="absolute right-3 top-3 h-4 w-4 opacity-50 pointer-events-none" data-id="element-401" />
      </div>;
});
Select.displayName = 'Select';
export { Select };